import { UNITED_STATES } from '../constants/UnitedStates';
import { isEqualCaseInsensitive } from './isEqualCaseInsensitive';

export function getStateAbbreviationForName(input: string) {
	return UNITED_STATES.find((state) =>
		isEqualCaseInsensitive(state.name, input),
	)?.abbreviation;
}
